import { z } from 'zod';
import { SBranchUser } from '@/src/modules/branch/data/schemas/responses/branch_user';
import { createStandardResponse } from '@/src/shared/data/schemas/responses/base';

export const SBranch = z.object({
  id: z.number(),
  name: z.string(),
  user: SBranchUser.optional(),
});
export type TBranch = z.infer<typeof SBranch>;

export const SBranchesResponse = createStandardResponse(z.array(SBranch));
export type TBranchesResponse = z.infer<typeof SBranchesResponse>;
